export const HERO_CONSTANTS = {
  title: "A Managed Cloud Service Provider You Can Trust",
  desc: "Cloud Infrastructure | Security | IoT | Datacenter Solutions",
  btnText: "Talk To Our Experts Today",
};
